import { forwardRef, type PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { PaginationButtonProps } from "./PaginationButton.types";

const basePaginationButtonClassName =
  "grid aspect-square cursor-pointer place-items-center font-semibold text-textColor";

const PaginationButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<PaginationButtonProps>
>(
  (
    {
      buttonType,
      pageNumber,
      currentPage,
      children,
      isFilled,
      ...paginationButtonProps
    },
    forwardedRef,
  ) => {
    const isCurrentPage = currentPage === pageNumber;

    return (
      <button
        ref={forwardedRef}
        type="button"
        className={cn(
          basePaginationButtonClassName,
          "font-medium disabled:cursor-not-allowed disabled:text-textInfo",
          {
            "font-medium text-textInfo":
              !isCurrentPage && buttonType === "page",
          },
        )}
        {...paginationButtonProps}
      >
        {children}
      </button>
    );
  },
);

PaginationButton.displayName = "PaginationButton";

export default PaginationButton;
